import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Message, Segment } from 'semantic-ui-react';

export const BookingNotFound: FC = () => {
    const { t } = useTranslation();

    return (
        <Segment>
            <Grid centered>
                <Grid.Column width={10}>
                    <Message negative>
                        <Message.Header>{t('error.booking_not_found.header')}</Message.Header>
                        <p>{t('error.booking_not_found.body')}.</p>
                    </Message>
                </Grid.Column>
            </Grid>
        </Segment>
    );
};
